var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepairinProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 149,
    viewBox: "0 0 100 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 149,
    rx: 5,
    fill: "#030303",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9662 69.0338C56.142 69.2096 56.2408 69.4481 56.2408 69.6967C56.2408 69.9453 56.142 70.1838 55.9662 70.3596L50.6629 75.6629C50.4871 75.8387 50.2486 75.9375 50 75.9375C49.7514 75.9375 49.5129 75.8387 49.3371 75.6629L44.0338 70.3596C43.858 70.1838 43.7592 69.9453 43.7592 69.6967C43.7592 69.4481 43.858 69.2096 44.0338 69.0338C44.2096 68.858 44.4481 68.7592 44.6967 68.7592C44.9453 68.7592 45.1838 68.858 45.3596 69.0338L50 73.6742L54.6404 69.0338C54.8162 68.858 55.0547 68.7592 55.3033 68.7592C55.5519 68.7592 55.7904 68.858 55.9662 69.0338Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3371 74.3371C49.5129 74.1613 49.7514 74.0625 50 74.0625C50.2486 74.0625 50.4871 74.1613 50.6629 74.3371L55.9662 79.6404C56.142 79.8162 56.2408 80.0547 56.2408 80.3033C56.2408 80.5519 56.142 80.7904 55.9662 80.9662C55.7904 81.142 55.5519 81.2408 55.3033 81.2408C55.0547 81.2408 54.8162 81.142 54.6404 80.9662L50 76.3258L45.3596 80.9662C45.1838 81.142 44.9453 81.2408 44.6967 81.2408C44.4481 81.2408 44.2096 81.142 44.0338 80.9662C43.858 80.7904 43.7592 80.5519 43.7592 80.3033C43.7592 80.0547 43.858 79.8162 44.0338 79.6404L49.3371 74.3371Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7192 84.2808C43.1806 86.7422 46.519 88.125 50 88.125C53.481 88.125 56.8194 86.7422 59.2808 84.2808C61.7422 81.8194 63.125 78.481 63.125 75C63.125 71.519 61.7422 68.1806 59.2808 65.7192C56.8194 63.2578 53.481 61.875 50 61.875C46.519 61.875 43.1806 63.2578 40.7192 65.7192C38.2578 68.1806 36.875 71.519 36.875 75C36.875 78.481 38.2578 81.8194 40.7192 84.2808ZM39.3934 85.6066C42.2064 88.4196 46.0218 90 50 90C53.9782 90 57.7936 88.4196 60.6066 85.6066C63.4196 82.7936 65 78.9782 65 75C65 71.0218 63.4196 67.2064 60.6066 64.3934C57.7936 61.5804 53.9782 60 50 60C46.0218 60 42.2064 61.5804 39.3934 64.3934C36.5804 67.2064 35 71.0218 35 75C35 78.9782 36.5804 82.7936 39.3934 85.6066Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepairinProgress);
export default __webpack_public_path__ + "static/media/repair in-progress.474ce21d9e99b72c785229c6ec8a9e3c.svg";
export { ForwardRef as ReactComponent };